import React from 'react';
import {withTranslation} from "react-i18next";
import {NextButton} from "../../shared/components/Buttons";

const PayButton = ({ disabled, onClick, t }) =>
    <NextButton
        type="submit"
        disabled={disabled}
        classname="!pr-4 !pl-6"
        onClick={onClick}
    >
        {t('followup.i_pay')}
    </NextButton>
;

export default withTranslation()(PayButton);
